/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { formatPreview } from './TileDetailPanelFormatter';

interface TileDetailPanelProps {
    previewData: any;
    visible: boolean;
    isLoading?: boolean;
    feedItemTitle?: string;
}

const TileDetailPanel: FunctionComponent<TileDetailPanelProps> = ({
    previewData,
    visible,
    isLoading = false,
    feedItemTitle,
}): JSX.Element | null => {
    if (!visible) return null;

    if (isLoading) {
        return (
            <div className="detail-panel detail-panel--loading">
                <div className="detail-panel-skeleton">
                    <div className="detail-panel-skeleton-title" />
                    <div className="detail-panel-skeleton-subtitle" />
                    <div className="detail-panel-skeleton-meta" />
                </div>
            </div>
        );
    }

    if (!previewData) return null;

    const { title, subtitle, ratings, channelName, dayLabel, timeRange, showRatings } =
        formatPreview(previewData, feedItemTitle);

    if (!title && !subtitle) return null;

    return (
        <div className="detail-panel">
            {title && <div className="detail-panel-title">{title}</div>}
            {subtitle && <div className="detail-panel-subtitle">{subtitle}</div>}
            <div className="detail-meta">
                {showRatings && ratings.length > 0 && (
                    <div className="detail-meta-badges">
                        {ratings.map((rating) => (
                            <div key={rating} className="detail-meta-badge">
                                {rating}
                            </div>
                        ))}
                    </div>
                )}
                {channelName && <span className="detail-meta-channel">{channelName}</span>}
                {dayLabel && (
                    <>
                        {channelName && <span className="detail-meta-dot">&middot;</span>}
                        <span className="detail-meta-text">{dayLabel}</span>
                    </>
                )}
                {timeRange && (
                    <>
                        <span className="detail-meta-dot">&middot;</span>
                        <span className="detail-meta-text">{timeRange}</span>
                    </>
                )}
            </div>
        </div>
    );
};

export default TileDetailPanel;
